module.exports = __webpack_public_path__ + "static/media/32.b8c4a8c2.png";